<template>
  <div v-if="hasSelectedFilters"
       class="serp__filter-filter--container  q-m-3 q-m-md-0 q-my-md-3 q-py-1 q-shadow-sm q-my-1 q-mb-3 q-rounded-3 q-bg-white ">
    <div class="q-accordion-item">
      <h6 class="q-accordion-header q-position-relative serp__filter-item--header q-accordion-button q-rotatable q-p-3 q-py-2 q-mt-0 q-fs-6 q-my-0 q-fw-semibold "
          :class="{'q-collapsed': isCollapsed, 'q-rotated': !isCollapsed}"
          @click="toggleAccordion"
          :aria-expanded="!isCollapsed.toString()"
      >
        {{ 'Użyte filtry' }}
      </h6>
      <div
          class="q-accordion-collapse"
          :class="{'q-collapse': isCollapsed, 'q-show': !isCollapsed}"
      >
        <div class="q-accordion-body q-p-1">
          <div class="serp__filter-item--container">
            <ClearFiltersButtonContainer v-if="!isMobileView"/>
            <MarkedFiltersContainer v-if="useMarkedFilters && hasSelectedFilters"/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts" setup>
import {inject, onMounted, onUnmounted, watch, defineProps, ref} from "vue";
import ClearFiltersButtonContainer
  from '@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButtonContainer.vue'
import MarkedFiltersContainer from '@/components/SerpPage/FiltersContainer/MarkedFilters/MarkedFiltersContainer.vue'

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {SmartSearchConfigInterface} from "@/core/types";

import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";

const props = defineProps(['filter', 'filterCollapsed'])
const isCollapsed = ref(props.filterCollapsed || false);

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value;
}


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const useMarkedFilters = SmartSearchConfig.value.serp.markedFilters.enabled

const {hasSelectedFilters} = storeToRefs(filtersStore)

watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

onMounted(() => {
  filtersStore.fetchFilters();
  window.addEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

</script>
<style>
.dropdown-divider__container, .filter-search__container {
  grid-column: 1 / -1;
}


.serp__filter-item--container {
  max-height: 312px;
  overflow-y: auto;
  overflow-x: hidden;

}


.q-accordion-item {
  background-color: #fff;
  border: 0px solid rgba(0, 0, 0, .125);
}

.q-accordion-header {
  cursor: pointer;
}

.q-accordion-button.q-rotatable::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: 1.25rem;
  display: block;
  position: absolute;
  right: 1rem;
  bottom: 0.5rem;
}

.q-rotatable::after {
  transform: rotate(0deg);
  transition: transform .2s ease-in-out;
}

.q-rotated::after {
  transform: rotate(180deg);
}


</style>
